import { getThumbUrl, getPublicUrl } from "components/Firebase/storage";

import EmptyAvatar from "../assets/emptyAvatar.webp";

export const fixAvatarUrl = avatarId => {
  return (avatarId || "").replace("https://models.readyplayer.me/", "common/avatars/");
};

export const getAvatarThumbnailPath = avatarId => {
  avatarId = fixAvatarUrl(avatarId);
  return avatarId ? avatarId.replace(/\.glb$/i, ".png") : "";
};

export const getAvatarImageSource = (avatarUrls, name) => {
  return {
    name,
    getFiles: async () =>
      // FileLibrary persists the selected file via `id` (see `onChange(files?.[0]?.id)` in CoverImageForm).
      // For the "Current bot avatar" source, that saved value must be the PNG storage path; `thumbnail`
      // is the resized webp preview shown in the picker.
      avatarUrls.map(url => ({ id: getAvatarThumbnailPath(url), thumbnail: getAvatarImage(url) })),
  };
};

export const getAvatarImage = avatarId => {
  const thumbnailPath = getAvatarThumbnailPath(avatarId);
  if (!thumbnailPath) return EmptyAvatar;
  const url = getThumbUrl(thumbnailPath, "320px");
  return url;
};

/**
 *
 * @param {string} avatarId
 * @param {Array} avatars
 * @returns {string} The name of the avatar or the avatarId if not found
 */
export const getAvatarName = (avatarId, avatars) => {
  if (!avatarId) return "";
  avatarId = fixAvatarUrl(avatarId);

  const name = avatars?.find(avatar => avatar?.id === avatarId)?.name;
  return name || "Unnamed Avatar";
};

export const getAvatarUrl = avatarId => {
  avatarId = fixAvatarUrl(avatarId);
  return getPublicUrl(avatarId);
};

/**
 * Avatar given to the bot character of a new scenario ("Corporate woman 1").
 *
 * The value is load-bearing: FormProvider applies alwaysApply defaults to already-saved
 * scenarios as pending changes, so changing it would start rewriting the bot avatar of every
 * scenario that does not set one.
 */
export const DEFAULT_BOT_AVATAR = "common/avatars/64eef8491db75f90dcfae642.glb";
